import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {
  Action,
  createAction,
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
  props,
} from '@ngrx/store';
import { Account, AccountRole } from '../../_models/Account';

export const name = 'account';

export interface AccountState extends EntityState<Account> {
  selectedName: number | null;
}

function select(a: Account): string {
  return a.name;
}

function sortBy(a: Account, b: Account): number {
  if (a.name < b.name) {
    return -1;
  } else if (a.name > b.name) {
    return 1;
  } else {
    return 0;
  }
}

const adapter: EntityAdapter<Account> = createEntityAdapter<Account>({
  selectId: select,
  sortComparer: sortBy,
});

const initialState: AccountState = adapter.getInitialState({
  selectedName: null,
});

/* ACTION */
export const loginAction = createAction(
  '[Account] Login'
);
export const loginActionSuccess = createAction(
  '[Account] Login success',
  props<{ payload: Account }>()
);
export const loginActionError = createAction('[Account] Login error');
export const logoutAction = createAction('[Account] Logout');

/* REDUCER */
const reducer = createReducer(
  initialState,
  on(loginActionSuccess, (state, { payload }) => {
    return adapter.addOne(payload, { ...state });
  }),
  on(logoutAction, (state) => {
    localStorage.removeItem('userToken');
    return adapter.removeAll(state);
  }),
  on(loginActionError, (state) => state)
);

export function accountReducer(
  state: AccountState | undefined,
  action: Action
): AccountState {
  return reducer(state, action);
}

/* SELECTOR */
const selectSessionState = createFeatureSelector<AccountState>(name);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();

const getAll = createSelector(selectSessionState, selectAll);

export const isLoggedIn = createSelector(
  getAll,
  (accounts) => accounts.length > 0
);
export const getCurrentUser = createSelector(getAll, (accounts) =>
  accounts.length > 0 ? accounts[0] : undefined
);
export const getCurrentUserRole = createSelector(getCurrentUser, (account) => {
  const debug = false;

  const accountRole: AccountRole = {
    id: -1,
    accesApplication: debug,
    accesAvancement: debug,
    accesCommandesEquipement: debug,
    accesEquipements: debug,
    accesHistorique: debug,
    accesLogs: debug,
    accesVec: debug,
    definitionPgm: debug,
    gestionSession: debug,
    profilGina: 'concat',
    gestionSp: debug,
    accesAlarmes: debug,
    acquittementAlarme: debug,
    definitionSp: debug,
    gestionEs: debug,
    quittancementAlarme: debug,
  };

  if (account) {
    account.roles.forEach((r) => {
      Object.keys(r).forEach((key) => {
        if (typeof accountRole[key] === 'boolean') {
          accountRole[key] = accountRole[key] || r[key];
        }
      });
    });
  }

  return accountRole;
});
